<script setup>
// Cartões de nível de assinatura, compartilhados pela criação e pela edição do contrato.
// A disponibilidade vem pronta em `options`; opções indisponíveis não podem ser escolhidas.
defineProps({
  options: { type: Array, required: true },
  modelValue: { type: String, default: 'simple' },
});

const emit = defineEmits(['update:modelValue']);

const choose = option => {
  if (option.available) emit('update:modelValue', option.value);
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <fieldset class="relative m-0 grid min-w-0 gap-3 border-0 p-0">
    <legend class="sr-only">Nível de assinatura</legend>
    <div
      class="grid gap-2 md:grid-cols-3"
      role="radiogroup"
      aria-label="Nível de assinatura"
    >
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        role="radio"
        :aria-checked="modelValue === option.value"
        :aria-disabled="!option.available"
        class="grid min-w-0 content-start gap-1.5 rounded-lg border p-3 text-left transition"
        :class="
          modelValue === option.value
            ? 'border-n-brand bg-n-brand/10'
            : option.available
              ? 'cursor-pointer border-n-weak hover:bg-n-alpha-2'
              : 'cursor-not-allowed border-n-weak opacity-60'
        "
        @click="choose(option)"
      >
        <span class="flex items-center gap-2">
          <span
            :class="option.icon"
            class="size-4 shrink-0 text-n-brand"
            aria-hidden="true"
          />
          <strong class="text-sm text-n-slate-12">{{ option.label }}</strong>
          <span
            v-if="option.current"
            class="ml-auto rounded-full bg-n-alpha-2 px-2 py-0.5 text-[11px] font-medium text-n-slate-11"
          >
            Atual
          </span>
        </span>
        <span class="text-xs leading-relaxed text-n-slate-11">
          {{ option.description }}
        </span>
        <span
          v-if="!option.available && option.reason"
          class="text-xs leading-relaxed text-n-amber-11"
        >
          {{ option.reason }}
        </span>
        <span
          v-else-if="
            option.value === 'biometric' && option.balance !== undefined
          "
          class="text-xs text-n-slate-11"
        >
          Saldo: {{ option.balance }} crédito(s)
        </span>
      </button>
    </div>
  </fieldset>
</template>
